import { createPrefetchableAsyncPaginatedDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getFirstPageData, getNextPageData } from './api';

/** @knip-ignore */
export const {
	Context: TopicPagePaginatedRecentPetitionsDataContext,
	Provider: TopicPagePaginatedRecentPetitionsDataContextProvider,
	useContext: useTopicPagePaginatedRecentPetitionsData,
	useAsyncData: useTopicPagePaginatedRecentPetitionsDataFromApi,
	prefetchAsyncData: prefetchTopicPagePaginatedRecentPetitionsDataFromApi,
} = createPrefetchableAsyncPaginatedDataContext({
	name: 'TopicPagePaginatedRecentPetitionsDataContext',
	dataProperty: 'recentPetitionsPaginatedData',
	getFirstPageData,
	getNextPageData,
	getUniqueId: (slug) => slug,
	errorHandler: pageDataErrorHandler(),
});
